import { observer } from 'mobx-react-lite'
import { store } from '@/src/stores/store'
import { useRunState } from '../../provider/useRunState'
import { PLAYER_HITBOX_HALF } from '../obstacles/obstacleCollision'

export const PlayerHitboxDebug = observer(function PlayerHitboxDebug() {
    const runState = useRunState()

    if (!store.debugShowObstacleHitboxes) return null

    return (
        <mesh
            position={[
                runState.snapshot.laneVisualX,
                runState.snapshot.jumpOffset + PLAYER_HITBOX_HALF.y,
                0,
            ]}
        >
            <boxGeometry
                args={[
                    PLAYER_HITBOX_HALF.x * 2,
                    PLAYER_HITBOX_HALF.y * 2,
                    PLAYER_HITBOX_HALF.z * 2,
                ]}
            />
            <meshBasicMaterial
                color='#4db6ff'
                wireframe
                transparent
                opacity={0.9}
                depthTest={false}
            />
        </mesh>
    )
})
